import { Clickstream } from '@gojek/clickstream-web'
import { asBoolean } from 'helpers/environment'
import { PageEventsConstants } from 'constants/clickStreamEvents'

const initClickStream = (token: string, url: URL) => {
    const clickStreamConfig = {
        event: {
            classification: {
                instant: Object.values(PageEventsConstants), // add eventName in this array to send it as QoS0 events. For more: https://go-jek.atlassian.net/wiki/spaces/EP/pages/2515574996/Clickstream+Web+Integration+Manual#Send-QoS0-events
            },
            group: 'web-gopay',
        },
        network: {
            url: new URL(url),
            headers: new Headers({
                Authorization: `Basic ${token}`,
            }),
            maxRetries: 5,
            timeBetweenTwoRetries: 1,
            timeToResumeRetries: 1,
        },
        debug: asBoolean(process.env.REACT_APP_ENABLE_CLICKSTREAM_DEBUGGING),
    }

    if (asBoolean(process.env.REACT_APP_ENABLE_CLICKSTREAM_DEBUGGING)) {
        console.log(
            'clickstream: initializing clickstream with config',
            clickStreamConfig
        )
    }

    return new Clickstream(clickStreamConfig)
}

const clickstream = initClickStream(
    process.env.REACT_APP_CLICKSTREAM_TOKEN,
    process.env.REACT_APP_CLICKSTREAM_URL
)

export default clickstream
